/* Refonte 2026, Phase 1. Sommaire automatique d'article : liste les H2 du corps, ajoute un id à chacun,
   n'affiche le sommaire qu'à partir du nombre minimal de H2 (réglage de section). Chargé en defer, aucun blocage. */
(function () {
  'use strict';
  function slug(text) {
    return text.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
  }
  function build() {
    var tocs = document.querySelectorAll('[data-selv-toc]');
    for (var t = 0; t < tocs.length; t++) {
      var toc = tocs[t];
      var section = toc.closest('.shopify-section') || document;
      var content = section.querySelector('[data-selv-article-content]');
      if (!content) continue;
      var headings = content.querySelectorAll('h2');
      var min = parseInt(toc.getAttribute('data-selv-toc-min'), 10) || 3;
      if (headings.length < min) continue;
      var list = toc.querySelector('.selv-toc__list');
      var used = {};
      for (var i = 0; i < headings.length; i++) {
        var h = headings[i];
        var text = (h.textContent || '').trim();
        if (!text) continue;
        var id = h.id || slug(text);
        while (used[id]) id += '-2';
        used[id] = true;
        h.id = id;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.className = 'animated-link--item';
        a.textContent = text;
        li.appendChild(a);
        list.appendChild(li);
      }
      toc.hidden = false;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
